
import React, { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import { Grid, FormControlLabel, Checkbox, Button } from "@mui/material";
import { addorModifyRolesDACRequestCall } from '../../../../../../../redux/actions/adminAccount-actions/roles-action/rolesRequest-action';

const DacTab = (props) => {

  const dispatch = useDispatch();

  const { allDac, selectedRoleId, setActiveModalNotice, mode, currentSelectedDacRoles, setIsModalOpen } = props;
  console.log("allDac", "selectedRoleId", "mode", "currentSelectedDacRoles", allDac, selectedRoleId, setActiveModalNotice, mode, currentSelectedDacRoles);
  const [dacSelected, setSelectedDac] = useState([]);

  const dacSelectedHandler = (event, dac) => {
    console.log("event.target", event.target);
    console.log("event.target.checked", event.target.checked);
    if (event.target.checked) {
      setSelectedDac([...dacSelected, dac]);
    } else {
      setSelectedDac(dacSelected.filter((item) => item.id !== dac.id));
    }
  };
  
  useEffect(() => {
    if (mode) {
      switch (mode) {
        case "edit":
          setSelectedDac(currentSelectedDacRoles);
          break;
        case "create":
          setSelectedDac([]);
          break;
        default:
          setSelectedDac([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);

  const cancelCreateModifyRoleDACHandler = () => {
    setIsModalOpen(false);
  };

  const createModifyRoleDACHandler = () => {
     const payload = dacSelected.map((dac) => {
      return {
        vamDacRoleIdPk: dac.id
      };
    });
    console.log("createModifyRoleDACHandler payload", payload);
    switch (mode) {
      case "edit":
        dispatch(
          addorModifyRolesDACRequestCall("edit", payload, selectedRoleId)
        );
        setIsModalOpen(false);
        setActiveModalNotice("message");
        break;
      case "create":
        dispatch(
          addorModifyRolesDACRequestCall("create", payload, selectedRoleId)
        );
        setIsModalOpen(false);
        setActiveModalNotice("message");
        break;
      default:
        null;
    }  
  };

  return (
    <div className="role_addOrModifyDAC">
       <h3>
        Select DAC Role (Role Name &amp; Doc Type Group) - {dacSelected.length}
      </h3>
        <Grid
        container
        md={12}
        spacing={4}
        className="role_grpTrainingDacContent"
      >
        {allDac && allDac.length > 0 ? (() => {
          const selectedIds = new Set(dacSelected.map(d => d.id));
          const sortedList = [...allDac].sort((a, b) => {
            const aSel = selectedIds.has(a.id) ? 1 : 0;
            const bSel = selectedIds.has(b.id) ? 1 : 0;
            if (aSel !== bSel) return bSel - aSel; 
            const aName = (a.name || "").toLowerCase();
            const bName = (b.name || "").toLowerCase();
            if (aName < bName) return -1;
            if (aName > bName) return 1;
            return String(a.id).localeCompare(String(b.id)); 
          });

          return sortedList.map(dac => (
            <Grid
              key={dac.id}
              item
              md={4}
              className="role_addOrModifyCheckbox"
            >
              <FormControlLabel
                sx={{ alignItems: 'flex-start' }}
                control={
                  <Checkbox
                      sx={{marginTop: -0.6}}                      
                      checked={
                        dacSelected.find(
                          (dacObject) => dacObject.id === dac.id
                        )
                          ? true
                          : false
                      }
                      onChange={(event) => dacSelectedHandler(event, dac)}
                      name={dac.name}
                  />
                }
                label={dac.name}
              />
            </Grid>
          ));
        })() : <div>No DAC roles available</div>}
      </Grid>
      <Grid
        container
        spacing={2}
        md={12}
        className="role_actionButons role_grpsTransDacsActionBtnsCommon"
      >
         <Button
          variant="outlined"
          color="error"
          className="btnRole btnRoleCancel"
          onClick={cancelCreateModifyRoleDACHandler}
        >
          Cancel
        </Button>
        <Button
          variant="outlined"
          color="success"
          className="btnRole"
          onClick={createModifyRoleDACHandler}
        >
          Submit
        </Button>
      </Grid>
    </div>
  );
};

export default DacTab;
